function haveOrderPermissionTo(resouceRequest, myOrderStatus) {
  let haveOrderPermission = false;

  const permissionsResources = resourses[resouceRequest];

  if (permissionsResources && myOrderStatus && myOrderStatus.length && typeof myOrderStatus === 'object') {
    haveOrderPermission = myOrderStatus.every(order => permissionsResources.indexOf(order.status) >= 0);
  }
  
  return haveOrderPermission;
}

const resourses = {
   // Buttons Resources
  "box-tag": [
    "A",
    "D",
  ],
  "price-tag": [
    "A",
    "D",
  ],
  "reconcile": [
    "A",
  ],
  "btn-po-report": [
    "A",
    "D",
    "N",
    "M",
  ],
  "load": [
    "A",
    "W",
    "S",
  ],
};

export default haveOrderPermissionTo;
